import { ALLIANCE_APPS } from './alliance-apps';

/**
 * This repo's app: the per-app values the shared Alliance components read.
 */
export const CURRENT_APP = ALLIANCE_APPS.events;

/**
 * Display fonts. Roboto is used everywhere else. The nav font applies to the
 * top-nav links and the wordmark; the title font to Sign In and System
 * Screen headings.
 */
export const CURRENT_APP_FONTS = {
  nav: {
    fontFamily: 'Oswald, sans-serif',
    fontWeight: 500,
    textTransform: 'uppercase',
  },
  // The app name beside the Alliance logo (design: 18px, 85% on phones)
  brand: {
    fontSize: 18,
    fontSizeCompact: 15,
    letterSpacing: '.04em',
  },
  title: {
    fontFamily: 'Oswald, sans-serif',
    fontWeight: 500,
    textTransform: 'uppercase',
  },
} as const;
